import { useRef, type ReactNode } from "react";
import { resolveLineTaxes, type DocumentTaxes, type DocumentTaxSet, type TaxMode } from "../../shared/document-taxes";
import { DocumentTaxesComposer } from "./DocumentTaxesComposer";

export function DocumentTaxControl({ children, lineNumber, mode, taxSet, taxes, onChange, onApplyToAll, open, onOpenChange }: {
  children: ReactNode; lineNumber: number; mode: TaxMode; taxSet: DocumentTaxSet; taxes: DocumentTaxes;
  open: boolean; onOpenChange(open: boolean): void;
  onApplyToAll?(taxes: DocumentTaxes, taxSet: DocumentTaxSet): void;
  onChange(taxes: DocumentTaxes, taxSet: DocumentTaxSet, mode: TaxMode): void;
}) {
  const trigger = useRef<HTMLButtonElement>(null);
  const selected = resolveLineTaxes(taxes, mode, taxSet);
  const label = selected.length ? selected.map(tax => tax.name).join(" + ") : "Add line tax";
  return <div className="document-rate-cell">{children}<button ref={trigger} type="button" className="document-tax-trigger" data-selected={selected.length > 0 || undefined} aria-label={`Line ${lineNumber} taxes: ${label}`} aria-haspopup="dialog" aria-expanded={open} onClick={() => onOpenChange(true)}>{label}</button>
    {open ? <DocumentTaxesComposer anchorRef={trigger} label={`Line ${lineNumber} taxes`} taxes={taxes} taxSet={taxSet} mode={mode} onApplyToAll={onApplyToAll} onChange={onChange} onClose={() => onOpenChange(false)}/> : null}
  </div>;
}
